<template>
	<div>
		<div class="arp-botoes-listagem-itens-ata" :class="{ '--flex-end': !hasItens || !isEditar || isAtaCancelada }">
			<div v-if="hasItens && isEditar && !isAtaCancelada" class="flex-column flex-sm-row d-flex justify-sm-start">
				<menu-acoes
					v-if="hasAuthority"
					class="botao-tamanho-arp mr-2"
					:nome-botao="menuAcoesItens.nome"
					:nome="menuAcoesItens.nome"
					cor-icone="--v-error-base"
					icone-primary="add_circle"
					icone-secondary="arrow_drop_down"
					:acoes-menu="menuAcoesItens.itens"
					tamanho-icone-primary="0.9rem"
					tamanho-icone-secondary="0.9rem"
					tamanho-icone-menu="18px"
					@adicionar-documento="abrirOuFecharModalAdicionarDocumento"
					@adicionar-anexo="abrirOuFecharModalNovoAnexo"
				>
				</menu-acoes>
				<menu-acoes
					v-if="hasAuthority && isProcessoDigitalAtivo"
					class="botao-tamanho-arp"
					:nome-botao="menuAcoesEmMassa.nome"
					:nome="menuAcoesEmMassa.nome"
					cor-icone="--v-error-base"
					icone-secondary="arrow_drop_down"
					:outlined="true"
					block
					corDeFundo="grey"
					:acoes-menu="menuAcoesEmMassa.itens"
					tamanho-icone-menu="18px"
					@juntar-itens="abrirModalJuntar"
					@assinar-itens="abrirOuFecharModalAssinaturaEletronicaEmLote"
				>
				</menu-acoes>
			</div>
			<div>
				<az-search
					:filter="filtro"
					simple-search-placeholder="Busque por título ou autor"
					@simple-search="buscar"
					ref="componenteAzSearch"
					@remove-filter="removerFiltros"
				>
				</az-search>
			</div>
		</div>

		<acessar-pedido-documentos-listagem
			:documentos="documentos"
			:total-paginas="totalPaginas"
			:total-itens="totalItens"
			:paginacao="paginacao"
			:pedido="infoPedido"
			@paginar="setPaginacaoListagem"
			@resetar-page="resetarPaginaListagem"
			@recarregar-listagem-externa="buscarDocumentos"
			@continuar-elaboracao-termo-desentranhamento="tratarEventoContinuarElaboracaoTermoDesentranhamento"
			@criar-termo-desentranhamento="tratarEventoCriarTermoDesentranhamento"
			@convidar-signatarios="tratarEventoConvidarSignatarios"
			@visualizar-signatarios="tratarEventoVisualizarSignatarios"
			@enviar-fornecedor="abrirModalEnviarFornecedorComBusca"
		></acessar-pedido-documentos-listagem>

		<az-container class="listagem">
			<template-listagem-vazia
				:textos="textosTemplateListagemVazia"
				:total-itens="totalItens"
				@botao-evento="abrirOuFecharModalAdicionarDocumento"
			>
				<template #acoes>
					<menu-acoes
						v-if="hasAuthority && menuAcoesItens && !isAtaCancelada"
						class="botao-tamanho-arp"
						:nome-botao="menuAcoesItens.nome"
						:nome="menuAcoesItens.nome"
						cor-icone="--v-error-base"
						icone-primary="add_circle"
						icone-secondary="arrow_drop_down"
						:acoes-menu="menuAcoesItens.itens"
						tamanho-icone-primary="0.9rem"
						tamanho-icone-secondary="0.9rem"
						tamanho-icone-menu="18px"
						@adicionar-documento="abrirOuFecharModalAdicionarDocumento"
						@adicionar-anexo="abrirOuFecharModalNovoAnexo"
					>
					</menu-acoes>
				</template>
			</template-listagem-vazia>
		</az-container>

		<div v-if="isEditar">
			<modal-novo-documento
				v-if="exibirModalAdicionarDocumento"
				id="modal-adicionar-documento"
				:idDocPai="Number(idPedido)"
				:exibir="exibirModalAdicionarDocumento"
				:tipo-documento="tipoModeloDocumento"
				buscar-todos-tipos
				@salvar-documento="salvarDocumento"
				@fechar-modal="abrirOuFecharModalAdicionarDocumento"
			>
			</modal-novo-documento>

			<modal-novo-anexo
				id="modal-novo-anexo"
				:exibir="exibirModalAdicionarAnexo"
				:infoAnexo="infoPedido"
				:info-modal-confirmacao="verificarSeNumeroProcessoJaEstaBloqueado()"
				:tipo-documento="[]"
				buscar-todos-tipos
				@salvar-anexo="salvarAnexo"
				@fechar-modal="abrirOuFecharModalNovoAnexo"
			>
			</modal-novo-anexo>
			<modal-selecao-tipo-assinatura
				:permissao-assinatura-digital="
					permissoes.pedidoUtilizacaoDocumentoProcessoDigitalAssinaturaDigitalCriar
				"
				:permissao-assinatura-eletronica="
					permissoes.pedidoUtilizacaoDocumentoProcessoDigitalAssinaturaEletronicaCriar
				"
				@assinar-eletronicamente="realizarAssinaturaEletronicaIndividual"
				@assinar-digitalmente="realizarAssinaturaDigital"
			></modal-selecao-tipo-assinatura>

			<modal-assinatura-eletronica
				v-if="exibirModalAssinaturaEmLote"
				titulo="Assinar Eletronicamente em massa"
				nome-botao-confirmar="Assinar"
				:exibir="exibirModalAssinaturaEmLote"
				@fechar-modal="abrirOuFecharModalAssinaturaEletronicaEmLote"
				@assinar-eletronicamente="realizarAssinaturaEletronicaEmLote"
			></modal-assinatura-eletronica>

			<modal-assinatura-progresso-lote
				v-if="exibirModalNotificacaoAssinaturaEletronicaEmLote"
				:exibir="exibirModalNotificacaoAssinaturaEletronicaEmLote"
				:documentos="assinaturasDocumentosNaoConcluidas"
				@atualizar="atualizarModalAssinaturasNaoConcluidas"
				@fechar-modal="fecharModalNotificacaoAssinaturaEletronicaEmLote"
				@assinar-individualmente-documento="realizarAssinaturaEletronicaIndividual"
				@assinar-eletronicamente-documento-lote="realizarAssinaturaEletronicaEmLote"
			></modal-assinatura-progresso-lote>

			<modal-informativo
				:mensagem-modal="mensagemInformativoModal"
				:exibir-modal="exibirModalInformativo"
				@confirmar-acao-informativo="fecharModalInformativo"
			></modal-informativo>

			<modal-assinatura-signatario
				v-if="exibirModalSignatarios"
				:signatarios="signatarios"
				:exibir="exibirModalSignatarios"
				:titulo="tituloModal"
				@fechar-modal="fecharModalSignatarios"
			></modal-assinatura-signatario>

			<formulario-assinatura-convite
				v-if="exibirModalConvidarSignatarios"
				:exibir-modal="exibirModalConvidarSignatarios"
				:titulo-modal="tituloModal"
				:titulo-documento="tituloDocumento"
				:id-associacao="idAssociacao"
				@fechar-modal="fecharModal"
				@confirmar-signatarios="convidarSignatarios"
				@excluir-signatario="tratarEventoExcluirSignatario"
				:func-buscar="buscarSignatarios"
			></formulario-assinatura-convite>

			<modal-enviar-fornecedor
				v-if="exibirModalEnviarFornecedor"
				:email-fornecedor="emailFornecedor"
				:id-associacao="idAssociacao"
				:exibir="exibirModalEnviarFornecedor"
				@fechar-modal="fecharModalEnviarFornecedor"
				@enviar-fornecedor="tratarEventoConfirmarEnviarFornecedor"
			></modal-enviar-fornecedor>

			<modal-confirmacao
				:titulo-modal="tituloModal"
				:mensagem="mensagemConfirmacaoModal"
				:subtitulo-modal="subtituloConfirmacaoModal"
				:exibir="exibirModalConfirmacao"
				@confirmar="confirmarAcaoModal"
				@fechar-modal="fecharAcaoModal"
			>
			</modal-confirmacao>
		</div>
	</div>
</template>
<script>
import ModalNovoAnexo from '@/views/components/documentos/novo-anexo/ModalNovoAnexo.vue'
import ModalNovoDocumento from '@/views/components/documentos/novo-documento/ModalNovoDocumento.vue'
import AcessarPedidoDocumentosListagem from '@/views/pages/pedido/acessar/documentos/listagem/AcessarPedidoDocumentosListagem.vue'
import mutationTypes from '@/core/constants/mutation-types'
import paginacaoListagem from '@/core/store/default/paginacaoListagem'
import documentos from '@/views/mixins/documento'
import { actionTypes, permissoes, routesNames, situacoes, tipoModeloDocumento } from '@/core/constants'
import { mapState } from 'vuex'
import _ from 'lodash'
import arpBpmMixin from '@/views/mixins/bpm/arp-bpm-mixin'
import ModalSelecaoTipoAssinatura from '@/views/components/assinatura/selecao-tipo/ModalSelecaoTipoAssinatura.vue'
import FormularioAssinaturaConvite from '@/views/components/documentos/signatario/convite/FormularioAssinaturaConvite.vue'
import ModalAssinaturaSignatario from '@/views/components/documentos/signatario/visualizar/ModalAssinaturaSignatario.vue'
import convidarSignatarios from '@/views/mixins/signatarios/convidar-signatarios'
import ModalConfirmacao from '@/views/components/ModalConfirmacao.vue'
import ModalAssinaturaProgressoLote from '@/views/components/assinatura/progresso-lote/ModalAssinaturaProgressoLote.vue'
import ModalAssinaturaEletronica from '@/views/components/assinatura/eletronica/ModalAssinaturaEletronica.vue'
import AssinarEletronicamenteDocPedidoLoteInput from '@/core/apiclient/processo-digital/models/AssinarEletronicamenteDocPedidoLoteInput'
import assinaturaPedido from '@/views/mixins/assinaturaPedido'
import enviarFornecedor from '@/views/mixins/enviar-fornecedor'
import ModalEnviarFornecedor from '@/views/components/documentos/enviar-fornecedor/ModalEnviarFornecedor.vue'

export default {
	name: 'acessar-pedido-documento-view',
	components: {
		ModalEnviarFornecedor,
		ModalAssinaturaEletronica,
		ModalAssinaturaProgressoLote,
		ModalConfirmacao,
		ModalSelecaoTipoAssinatura,
		AcessarPedidoDocumentosListagem,
		ModalNovoAnexo,
		ModalNovoDocumento,
		FormularioAssinaturaConvite,
		ModalAssinaturaSignatario,
	},
	mixins: [assinaturaPedido, documentos, arpBpmMixin, convidarSignatarios, enviarFornecedor],
	inject: ['idPedido', 'isEditar'],
	data() {
		return {
			documentos: [],
			totalItens: 0,
			totalPaginas: 0,
			paginacao: paginacaoListagem(['id']),
			filtroInterno: this.getFiltros(),
			exibirModalAdicionarDocumento: false,
			exibirModalAdicionarAnexo: false,
			exibirModalConfirmacao: false,
			idAssociacao: null,
			mensagemConfirmacaoModal: '',
			subtituloConfirmacaoModal: '',
			confirmarAcaoModal: () => {},
			fecharAcaoModal: () => {},
			exibirModalSignatarios: false,
			exibirModalConvidarSignatarios: false,
			exibirModalEnviarFornecedor: false,
			tituloDocumento: '',
			tituloModal: '',
			textosTemplateListagemVazia: {
				titulo: 'Você não possui documento adicionado',
				mensagem: 'Clique no botão para começar',
			},
			emailFornecedor: '',
			tipoModeloDocumento: [tipoModeloDocumento.PEDIDO_UTILIZACAO.value, tipoModeloDocumento.OUTROS.value],
			isProcessoDigitalAtivo: this.$store.state.parametrosSistema.isProcessoDigitalAtivo,
			menuAcoesItens: this.getMenuAcoesItens(),
			menuAcoesEmMassa: this.getMenuAcoesEmMassa(),
			actionsSignatarios: actionTypes.PEDIDO.DOCUMENTOS,
			infoModalConfirmacao: {
				tituloModal: 'Deseja realmente adicionar anexo?',
				mensagem: 'Ao adicionar anexo, o número do processo não poderá ser alterado. Deseja continuar?',
				isModalConfirmacao: false,
			},
		}
	},
	computed: {
		...mapState({
			filtro: (state) => state.pedido.documentoPedido.filtro,
			infoPedido: (state) => state.pedido.informacoesPedido,
			itensSelecionados: (state) => state.pedido.documentoPedido.documentosSelecionados,
			parametrosSistema: (state) => state.parametrosSistema,
		}),
		hasItens() {
			return this.totalItens > 0
		},
		isAtaCancelada() {
			return this.infoPedido.ataRegistroPreco?.situacao === situacoes.ATA.CANCELADO.value
		},
	},
	async created() {
		try {
			this.ativarCarregamentoManual()
			await this.carregarInstancia(`${this.idPedido}`)
			await this.buscarDocumentos()
		} finally {
			this.desativarCarregamentoManual()
		}
	},
	methods: {
		buscarSignatarios(idAssociacao) {
			return this.$store.dispatch(actionTypes.PEDIDO.DOCUMENTOS.BUSCAR_SIGNATARIOS, idAssociacao)
		},
		async tratarEventoCriarTermoDesentranhamento(documento) {
			this.setMensagemLoading('Carregando o termo de desentranhamento...')
			const termoDesentranhamento = await this.$store.dispatch(
				actionTypes.PEDIDO.DOCUMENTOS.PROCESSO_DIGITAL.DESENTRANHAMENTO.CRIAR_TERMO,
				documento.id,
			)

			await this.$router.push({
				name: routesNames.PEDIDO.PROCESSO_DIGITAL.DESENTRANHAMENTO.PROCESSO_REDIGIR_TERMO_DESENTRANHAMENTO,
				params: {
					id: this.idPedido,
					idTermo: termoDesentranhamento.documento.idAssociacao,
				},
			})
		},
		async tratarEventoConfirmarEnviarFornecedor(obj) {
			try {
				await this.$store.dispatch(actionTypes.PEDIDO.DOCUMENTOS.ENVIAR_FORNECEDOR, {
					...obj,
					emailDocumentoPedido: 'ORDEM_UTILIZACAO',
				})

				this.mostrarNotificacaoSucessoDefault()
				this.fecharModalEnviarFornecedor()
			} catch (e) {
				this.mostrarNotificacaoErroDefault()
			}
		},
		async buscarAssinaturasNaoConcluidasEValidarAssinaturaEmLote() {
			this.validarAssinaturaEmLote(await this.buscarAssinaturasNaoConcluidas())
		},
		async atualizarModalAssinaturasNaoConcluidas() {
			this.limparDocumentosAssinaturasNaoConcluidas()
			this.setMensagemLoading('Carregando documentos com assinaturas não concluídas...')
			this.assinaturasDocumentosNaoConcluidas = await this.buscarAssinaturasNaoConcluidas()
		},
		async buscarAssinaturasNaoConcluidas() {
			const { itens } = await this.$store.dispatch(
				actionTypes.PEDIDO.DOCUMENTOS.BUSCAR_ASSINATURAS_NAO_CONCLUIDAS,
				this.idPedido,
			)

			return itens
		},
		async tratarEventoContinuarElaboracaoTermoDesentranhamento(documento) {
			await this.$router.push({
				name: routesNames.PEDIDO.PROCESSO_DIGITAL.DESENTRANHAMENTO.PROCESSO_REDIGIR_TERMO_DESENTRANHAMENTO,
				params: {
					id: this.idPedido,
					idTermo: documento.idReferenciaTermoDesentranhamento,
				},
			})
		},
		async buscarDocumentos() {
			this.limparDocumentosSelecionados()

			let { itens, totalElements, totalPages } = await this.$store.dispatch(
				actionTypes.PEDIDO.DOCUMENTOS.BUSCAR_POR_FILTRO,
				this.idPedido,
			)

			if (this.isProcessoDigitalAtivo) {
				await this.buscarAssinaturasNaoConcluidasEValidarAssinaturaEmLote()
				this.documentos = await this.buscarSignatariosDocumento(itens)
			} else {
				this.documentos = itens
			}

			this.totalItens = totalElements
			this.totalPaginas = totalPages
		},
		async buscar(searchText) {
			if (searchText) this.filtro.tituloOuAutor.value = searchText
			this.resetarPaginaListagem()
			await this.buscarDocumentos()
		},
		async salvarDocumento(doc) {
			const documento = await this.adicionarDocumentoPedido(doc)
			this.mostrarNotificacaoSucessoDefault()
			await this.buscarDocumentos()
			this.redirecionarPara(documento.urlEdicao)
		},
		async adicionarDocumentoPedido(doc) {
			return await this.$store.dispatch(actionTypes.PEDIDO.DOCUMENTOS.DOCUMENTO.EDITOR_TEXTO.ADICIONAR, doc)
		},
		async salvarAnexo() {
			await this.$store.dispatch(
				actionTypes.PEDIDO.DOCUMENTOS.ANEXO.CRIAR,
				this.$store.state.campoArquivoNovo.documentoComAnexo,
			)
			await this.buscarDocumentos()
			this.mostrarNotificacaoSucessoDefault()
		},
		async removerFiltros() {
			if (this.filtro.tituloOuAutor.value) {
				this.filtro.tituloOuAutor.value = this.filtro.tituloOuAutor.default
				this.filtroInterno.tituloOuAutor.value = this.filtroInterno.tituloOuAutor.default
			}
			await this.buscarDocumentos()
		},
		resetarPaginaListagem() {
			this.$store.commit(mutationTypes.PEDIDO.DOCUMENTOS.LISTAGEM.RESETAR_PAGINA)
			this.limparDocumentosSelecionados()
		},
		abrirOuFecharModalAdicionarDocumento() {
			this.exibirModalAdicionarDocumento = !this.exibirModalAdicionarDocumento
		},
		async abrirOuFecharModalNovoAnexo() {
			this.exibirModalAdicionarAnexo = !this.exibirModalAdicionarAnexo
			await this.$store.dispatch(actionTypes.PEDIDO.BUSCAR_INFORMACOES, this.$route.params.id)
		},
		setPaginacaoListagem(paginacao) {
			this.$store.commit(mutationTypes.PEDIDO.DOCUMENTOS.LISTAGEM.SET_PAGINACAO, paginacao)
			this.buscarDocumentos()
		},
		getFiltros() {
			return _.cloneDeep(this.$store.state.pedido.documentoPedido.filtro)
		},
		async juntarItensEmMassa() {
			const payload = {
				id: this.infoPedido.id,
				idsDocumentos: this.itensSelecionados.map((item) => item.id),
			}

			await this.$store.dispatch(actionTypes.PEDIDO.DOCUMENTOS.PROCESSO_DIGITAL.JUNTAR_LOTE_DOCUMENTOS, payload)
			await this.buscarDocumentos()
			this.limparDocumentosSelecionados()
			this.fecharModalJuntar()
			this.mostrarNotificacaoSucesso('Documentos foram juntados ao processo digital.')
		},
		// eslint-disable-next-line vue/no-unused-properties
		async validarSeDocumentoFoiAssinadoNoProcessoDigital(documento) {
			await this.$store.dispatch(
				actionTypes.PEDIDO.DOCUMENTOS.PROCESSO_DIGITAL.VALIDAR_DOCUMENTO_ASSINADO,
				documento.id,
			)
		},
		// eslint-disable-next-line vue/no-unused-properties
		async assinarDigitalmenteDocumento(documento) {
			await this.$store.dispatch(
				actionTypes.PEDIDO.DOCUMENTOS.PROCESSO_DIGITAL.ASSINAR_DIGITALMENTE,
				documento.id,
			)
		},
		// eslint-disable-next-line vue/no-unused-properties
		async assinarEletronicamenteDocumento(documento) {
			this.setMensagemLoading('Assinando documento eletronicamente...')
			await this.$store.dispatch(
				actionTypes.PEDIDO.DOCUMENTOS.PROCESSO_DIGITAL.ASSINAR_ELETRONICAMENTE,
				documento.id,
			)
		},
		// eslint-disable-next-line vue/no-unused-properties
		async assinarEletronicamenteDocumentoEmLote(idsDocumentosAssinatura) {
			this.setMensagemLoading('Assinando documentos eletronicamente...')
			await this.$store.dispatch(
				actionTypes.PEDIDO.DOCUMENTOS.PROCESSO_DIGITAL.ASSINAR_ELETRONICAMENTE_LOTE,
				new AssinarEletronicamenteDocPedidoLoteInput(Number(this.idPedido), idsDocumentosAssinatura),
			)
		},
		abrirModalJuntar() {
			if (this.itensSelecionados.length === 0) {
				this.mostrarNotificacaoErro('Não possui itens para juntar!')
			} else {
				const mensagemJuntarItens =
					'Clique no botão de Confirmar se deseja que os documentos/anexos sejam enviados para o processo digital.'
				const subtituloJuntarItens = 'Gostaria de juntar os documentos ao processo digital?'
				const tituloModalJuntarItens = 'Juntar'

				this.confirmarAcaoModal = this.juntarItensEmMassa
				this.fecharAcaoModal = this.fecharModalJuntar

				this.tituloModal = tituloModalJuntarItens
				this.mensagemConfirmacaoModal = mensagemJuntarItens
				this.subtituloConfirmacaoModal = subtituloJuntarItens

				this.exibirModalConfirmacao = true
			}
		},
		fecharModalJuntar() {
			this.subtituloConfirmacaoModal = ''
			this.exibirModalConfirmacao = false
			this.itemSelecionado = null
		},
		limparDocumentosSelecionados() {
			this.$store.commit(mutationTypes.PEDIDO.DOCUMENTOS.CHECKBOX.DESFAZER_SELECAO_ITENS_LISTAGEM)
		},
		getMenuAcoesItens() {
			return {
				nome: 'Adicionar',
				itens: [
					{
						titulo: 'Documento',
						icone: {
							nome: 'description',
						},
						evento: 'adicionar-documento',
						authorization: permissoes.pedidoUtilizacaoDocumentoEditorTextoCriar,
					},
					{
						titulo: 'Anexo',
						icone: {
							nome: 'attach_file',
						},
						evento: 'adicionar-anexo',
						authorization: permissoes.pedidoUtilizacaoDocumentoAnexoCriar,
					},
				],
			}
		},
		getMenuAcoesEmMassa() {
			return {
				nome: 'MAIS AÇÕES',
				itens: [
					{
						titulo: 'Assinar',
						icone: {
							nome: 'mdi-draw-pen',
						},
						evento: 'assinar-itens',
						authorization:
							permissoes.pedidoUtilizacaoDocumentoProcessoDigitalAssinaturaEletronicaLoteIniciar,
					},
					{
						titulo: 'Juntar',
						icone: {
							nome: 'mdi-file-replace',
						},
						evento: 'juntar-itens',
						authorization: permissoes.pedidoUtilizacaoDocumentoProcessoDigitalJuntarEmLote,
					},
				],
			}
		},
		verificarSeNumeroProcessoJaEstaBloqueado() {
			if (this.infoPedido.podeAlterarNumeroProcesso) {
				this.infoModalConfirmacao.isModalConfirmacao = true
			} else {
				this.infoModalConfirmacao.isModalConfirmacao = false
			}

			return this.infoModalConfirmacao
		},
	},
}
</script>
Senha@123

<style scoped lang="stylus">
.arp-botoes-listagem-itens-ata
	display flex;
	margin 25px 0
	place-content: space-between

.--flex-end
	place-content: flex-end

	> div
		margin-right 15px

.d-flex
	gap: 10px
</style>
